var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('div',[(_vm.form.cancelada_em == null)?_c('QuotationBackButton',{staticClass:"ml-4",on:{"back":_vm.previousPage}}):_vm._e()],1),_c('v-spacer'),_c('div',[(_vm.form != null)?_c('ResumeProcessQuotationAgro',{attrs:{"form":_vm.form},on:{"return":_vm.previousPage}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }